import { z } from 'zod';

export const stepCalculationFormSchema = z.object({});

export type StepCalculationFormValues = z.infer<
  typeof stepCalculationFormSchema
>;
